export default "__VITE_ASSET__dee2585e__"